import { Lesson } from '../../utils/translation';
import { beginnerEnglish, intermediateEnglish, advancedEnglish } from './english_content';
import { SUPPORTED_LANGUAGES, SupportedLanguage } from './languages';
import { getTranslation } from '../../utils/translation';

// Helper to determine category based on index or content (simplified for now)
const getCategory = (index: number): string => {
  const categories = [
    'Greetings', 'Family', 'Food', 'Routine', 'Hobbies', 
    'Weather', 'Home', 'Work', 'Shopping', 'Travel', 
    'Health', 'Time'
  ];
  // Distribute 365 lessons across categories roughly
  return categories[Math.floor((index / 365) * categories.length)] || 'General';
};

const generateLessonsForLevel = (
  level: 'Beginner' | 'Intermediate' | 'Advanced',
  phrases: string[]
): Lesson[] => {
  return phrases.map((prompt, index) => {
    // Determine category based on index ranges defined in english_content.ts comments
    let category = 'General';
    if (level === 'Beginner') {
      if (index < 30) category = 'Greetings';
      else if (index < 60) category = 'Family';
      else if (index < 90) category = 'Food';
      else if (index < 120) category = 'Routine';
      else if (index < 150) category = 'Hobbies';
      else if (index < 180) category = 'Weather';
      else if (index < 210) category = 'Home';
      else if (index < 240) category = 'Work';
      else if (index < 270) category = 'Shopping';
      else if (index < 300) category = 'Travel';
      else if (index < 330) category = 'Health';
      else category = 'Time';
    } else if (level === 'Intermediate') {
      if (index < 30) category = 'Greetings';
      else if (index < 60) category = 'Work';
      else if (index < 90) category = 'Travel';
      else if (index < 120) category = 'Food';
      else if (index < 150) category = 'Hobbies';
      else if (index < 180) category = 'Health';
      else if (index < 210) category = 'Technology';
      else if (index < 240) category = 'Nature';
      else if (index < 270) category = 'Shopping';
      else if (index < 300) category = 'Education';
      else if (index < 330) category = 'Culture';
      else category = 'General';
    } else {
      if (index < 30) category = 'Business';
      else if (index < 60) category = 'Academic';
      else if (index < 90) category = 'Global';
      else if (index < 120) category = 'Arts';
      else if (index < 150) category = 'Technology';
      else if (index < 180) category = 'Psychology';
      else if (index < 210) category = 'Philosophy';
      else if (index < 240) category = 'Vocabulary';
      else if (index < 270) category = 'Grammar';
      else if (index < 300) category = 'Idioms';
      else if (index < 330) category = 'Debate';
      else category = 'Abstract';
    }

    return {
      id: `${level.toLowerCase()}-${index + 1}`,
      title: `${category} Practice ${index + 1}`,
      level,
      description: `Daily practice for ${level.toLowerCase()} level: ${category}`,
      prompt,
      translation: prompt, // This will be dynamically replaced by the UI using the translation utility
      keywords: prompt.split(' ').filter(w => w.length > 3).map(w => w.replace(/[^a-zA-Z]/g, '')),
      category
    };
  });
};

export const allLessons = [
  ...generateLessonsForLevel('Beginner', beginnerEnglish),
  ...generateLessonsForLevel('Intermediate', intermediateEnglish),
  ...generateLessonsForLevel('Advanced', advancedEnglish)
];
